import {makeStyles} from "@material-ui/styles";
import {createStyles, Theme} from "@material-ui/core";

export const useCarePractitionerActionSelectorStyle =  makeStyles((theme: Theme) => createStyles({
    icon: {
        width: '20px',
        height: '20px',
        margin: '0 10px 0 0',
    }
}));